const colors = {
  domains: {
    blueLighter: "#EAF1F9",
    green: "#00A183",
    greenLight: "#E3F3F1",
    grey: "#CECFD4",
    greyLight: "#F5F5F5",
    orange: "#EF7C18",
    orangeLight: "#FBEEE6",
    purple: "#76529C",
    purpleLight: "#EFEBF3",
    red: "#C5393A",
    redLight: "#F7E9E9",
    yellow: "#F2C314",
    yellowLight: "#FAF6E6",
  },
  background: "#FCFCFD",
  black: "#333333",
  blue: "#0074B8",
  blueDark: "#21408F",
  blueDarker: "#0B276C",
  blueMedium: "#CBDDF0",
  blueLight: "#EDF5FA",
  blueLighter: "#EAF1F9",
  grey600: "#0B1026",
  grey500: "#3C4051",
  grey400: "#6D707D",
  grey200: "#CECFD4",
  grey100: "#E7E7E9",
  grey50: "#F5F5F7",
  orange: "#EF7C18",
  red: "#C5393A",
  white: "#ffffff",
};

const typography = {
  fontFamilies: {
    aileron: "Aileron",
  },
  fontWeights: {
    bold: "bold",
    semiBold: "semiBold",
    regular: "regular",
  },
  fontSizes: {
    veryBig: "2.5rem",
    big: "1.5rem",
    medium: "1.25rem",
    regular: "1rem",
    small: ".75rem",
    xsmall: ".625rem",
    xxsmall: ".5rem",
  },
};

const theme = {
  name: "Default theme",
  colors,
  typography,
  components: {},
};

export default theme;
